/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-06-17 16:08:20
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2024-07-03 11:07:14
 * @FilePath: \crane-safety-manager\src\Layouts\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import withRouter from '../Common/withRouter';
import { ConfigProvider, Layout } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import HeaderLayout from './Header';
import FooterLayout from './Footer';
import SidebarLayout from './SidebarLayout';
import { ThemeProvider, styled } from 'styled-components';
import { themecolor, darkthemecolors } from '../../src/config';
import { useTheme }  from '../Common/ThemeContext';

const { Content } = Layout;

// Define the StyleLayout styled component outside the functional component
const StyleLayout = styled(Layout)`
  margin-left: ${themecolor.components.Menu.verticalSidebarWidth}px;
  position: relative;
  padding: calc(${themecolor.token.controlHeight}px * 2) 24px 0;

  .ant-breadcrumb {
    ol {
      justify-content: end;
    }
  }

  @media screen and (max-width: 768px) {
    margin-left: 0;
  }
`;

const LayoutComponents = ({ children }) => {

  const { theme, toggleTheme } = useTheme();

  const handleToggleMode = () => {
    toggleTheme();
  };
    return (
        <React.Fragment>
          <ThemeProvider theme={theme === 'dark' ? darkthemecolors : themecolor}>
          <ConfigProvider theme={theme === 'dark' ? darkthemecolors : themecolor} locale={zhCN}>
            <SidebarLayout theme={theme} />
            <Layout style={{ minHeight: '100vh',maxHeight: '100vh'}}>
                <HeaderLayout darkMode={theme} handleToggleMode={handleToggleMode} />
                <StyleLayout id='antLayoutContent'>
                    <Content style={{overflow:'hidden'}}>
                        {children}
                    </Content>
                </StyleLayout>
                <FooterLayout />
            </Layout>
          </ConfigProvider>
        </ThemeProvider>
        </React.Fragment>
    );
};

export default withRouter(LayoutComponents);